import React from 'react';
import { RootWrapper } from './src/components/RootWrapper';
import { PageWrapper } from './src/components/PageWrapper';
export var wrapRootElement = function wrapRootElement(_ref) {
  var element = _ref.element;
  return /*#__PURE__*/React.createElement(RootWrapper, null, element);
};
export var wrapPageElement = function wrapPageElement(_ref2) {
  var element = _ref2.element,
      props = _ref2.props;
  return /*#__PURE__*/React.createElement(PageWrapper, {
    props: props
  }, element);
};